import { HealthGuard } from "@/components/health/health-guard";
import { ModuleRouter } from "@/components/module-router/module-router";

export function RamRoutes() {
  return (
    <>
      <HealthGuard />
      <ModuleRouter moduleId="ram" />
    </>
  );
}
